import "./studentlogin.css";
import { useReducer, useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import * as Action from "../../../store/redux/student_reducer.js";
import axios from "axios";
import IsLoading from "../../../isLoading";
import Lock from "@mui/icons-material/Lock";
import Person from "@mui/icons-material/Person";
import Logo from "../public-routes-images/logos/Manga_Cons _Logo.png";
import { Link, useNavigate } from "react-router-dom";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

let studentData;

export default function StudentLogin() {
  const [showPassword, setShowPassword] = useState(false);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [isloadin, setIslaoding] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [studLoginData, setstudLoginData] = useReducer(
    (reqest, response) => {
      return { ...reqest, ...response };
    },
    { user_name: "", stud_password: "" },
  );

  const executeLogin = async () => {
    const data = {
      user_name: studLoginData.user_name,
      stud_password: studLoginData.stud_password,
    };
    setIslaoding(true);
    await axios
      .post(`${process.env.REACT_APP_SERVER_SCRIPT_HOST}/student_login`, data)
      .then((response) => {
        studentData = response.data;
        console.log(response);

        dispatch(DispatchStudentData());
        if (response?.data.status === 201) {
          enqueueSnackbar(`Login success!`, {
            variant: "success",
            autoHideDuration: 3000,
            ContentProps: {
              style: { fontSize: "16px", fontWeight: "bold" },
            },
          });

          // navigate(
          //   `/students/${studentData?.info?._id}/account/ameenatLove234/portal`,
          // );
        } else if (response?.data.status === 401) {
          enqueueSnackbar(`${response?.data.message}`, {
            variant: "error",
            autoHideDuration: 3000,
            ContentProps: {
              style: { fontSize: "16px", fontWeight: "bold" },
            },
          });
        }
        setIslaoding(false);
      })
      .catch((err) => {
        setIslaoding(false);
        console.log(err);
      });
  };

  const DispatchStudentData = () => async (dispatch) => {
    try {
      // dispatch an action
      dispatch(Action.startStudentAction({ studentData }));
    } catch (error) {
      console.log(error);
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      executeLogin();
    }
  };

  // TOGGLE SHOW PASSWORD
  const togglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };
  return (
    <section className="section-student-login">
      {isloadin ? <IsLoading /> : null}
      <div className="student-login-container g g2">
        <div className="student-login-form-cont fx-cl space3">
          <figure className="loginLogo" style={{ width: "4.5rem" }}>
            <img src={Logo} alt="logo" />
          </figure>
          <header className="fx-cl space1">
            <h2>
              Login to your <Link>Account</Link>
            </h2>
            <span>Welcome back, enter your details to log in:</span>
          </header>
          <form className="student-login-form fx-cl space2">
            <div className="fx-ac space1">
              <span>
                <Person fontSize="large" />
              </span>
              <input
                onKeyPress={handleKeyPress}
                name="user_name"
                value={studLoginData.user_name}
                onChange={(event) =>
                  setstudLoginData({ user_name: event.target.value })
                }
                type="text"
                placeholder="Adm number..."
              />
            </div>

            <div className="fx-ac space1">
              <span>
                <Lock fontSize="large" />
              </span>
              <input
                onKeyPress={handleKeyPress}
                name="stud_password"
                value={studLoginData.stud_password}
                onChange={(event) =>
                  setstudLoginData({ stud_password: event.target.value })
                }
                type={showPassword ? "text" : "password"}
                placeholder="enter password"
              />
              <span
                style={{ cursor: "pointer" }}
                onClick={togglePasswordVisibility}
              >
                {showPassword ? (
                  <VisibilityOff fontSize="large" />
                ) : (
                  <Visibility fontSize="large" />
                )}
              </span>
            </div>
            <aside className="fx-jb">
              <span>
                <span>
                  {" "}
                  <input type="checkbox" />
                </span>{" "}
                remember me
              </span>
              <span>
                <Link>
                  <strong>forgot password?</strong>
                </Link>
              </span>
            </aside>
            <Link>
              <button onClick={() => executeLogin()}>Login</button>
            </Link>
          </form>
          <aside style={{ textAlign: "center" }}>
            dont have an account?{" "}
            <Link to="/registrations">
              <strong>Create an account</strong>
            </Link>
          </aside>
        </div>
        <div className="student-login-disc fx-cl space4 rwdHide">
          <figure>
            <img src={Logo} alt="image" />
          </figure>
          <div>
            <h4>Connect to your Institution</h4>
            <p>
              Login to student portal using your admission number and
              password{" "}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
